/**
 * The eight compass points a guidebook gives a piece of rock's aspect in.
 * Mirrors `Zone::EXPOSURES` — anything finer belongs in the crag's description.
 */
export const ZONE_EXPOSURES = ['n', 'ne', 'e', 'se', 's', 'sw', 'w', 'nw'] as const;

export type ZoneExposure = (typeof ZONE_EXPOSURES)[number];

export interface Zone {
  id: string;
  name: string;
  slug: string;
  location_id: string;
  position: number | null;
  image_url: string | null;
  image_small_url: string | null;
  /**
   * Which way this sector faces, and so when it is in the sun. On the sector
   * rather than on the crag because that is where it is true: one cliff has a
   * wall that bakes all afternoon and another round the corner that never sees
   * the sun. Only crags fill it in.
   */
  exposure?: ZoneExposure | null;
  /**
   * How this sector's routes are drawn on its photo — a property of the
   * picture, not of any one route, so a cliff's whole topo reads as one.
   * Copied onto each route's line when it is saved.
   */
  line_thickness: number;
  line_corridor: number;
  climbs_count: number;
  created_at: string;
  updated_at: string;
}

export interface ZoneSummary {
  id: string;
  name: string;
  slug: string;
  image_small_url: string | null;
}

export interface ZoneResponse {
  data: {
    id: string;
    type: 'zone';
    attributes: Zone;
  };
}

export interface ZonesListResponse {
  data: Array<{
    id: string;
    type: 'zone';
    attributes: Zone;
  }>;
}
